var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Title',{attrs:{"title":_vm.$t('MATRICULAS.CONTATOS')}}),_c('b-table',{attrs:{"items":_vm.contatos,"fields":_vm.tabela.fields,"empty-text":_vm.$t('GERAL.NENHUM_REGISTRO'),"head-variant":"light","stacked":"md","show-empty":"","responsive":"","striped":"","hover":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }